import { useTranslation } from 'react-i18next'

import { getTranslatedOptions } from '../../../../utils/translation'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../Form'
import { FormikField } from '../../../Formik'
import { ButtonSelect } from '../../../Select'
import {
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_OPTIONS,
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_RECIPIENTS_FIELD_NAME,
} from '../RequestProfileEmailAudienceModal.constants'

function FormFields() {
  const { t } = useTranslation()

  const options = getTranslatedOptions({
    options: REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_OPTIONS,
    t,
  })

  return (
    <FormFieldsContainer>
      <FormikField
        Component={FormFieldSelectNG}
        Field={FieldStackedLabel}
        Select={ButtonSelect}
        controlProps={{
          indicatorsProps: {
            ButtonClear: null,
          },
        }}
        fieldComponentProps={{
          label: t('RequestProfile.EmailAudienceModalRecipientsLabelKey'),
        }}
        listProps={{
          headerProps: { Search: null },
        }}
        name={REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_RECIPIENTS_FIELD_NAME}
        options={options}
      />
    </FormFieldsContainer>
  )
}

export default FormFields
